import localeRouting from '@/config/localeRouting.json';

/** Single source of truth: config/localeRouting.json */
export const DEFAULT_LOCALE = localeRouting.defaultLocale;
export const VALID_LOCALES: readonly string[] = localeRouting.validLocales;
export type ValidLocale = (typeof VALID_LOCALES)[number];

// Set version for faster lookups (used in middleware)
export const VALID_LOCALES_SET = new Set<string>(VALID_LOCALES);
